import { GetterTree } from 'vuex'
import { Reports } from './types'
import { RootState } from '../types'

export const getters: GetterTree<Reports, RootState> = {
    
    getReports: state => {
        const resp = state.filterReports.filter((obj, index) => {
            return index === state.filterReports.findIndex(o => obj.id_informe === o.id_informe)
          })
        return resp
    },
    getCurrentReport: state => {
        return state.currentReport
    },
    graphView: state => {
        return state.graphView
    },
    getOndemand: state=> {
        return state.ondemand
    },
    useMock: state => {
        return state.useMock
    }
}